export const vuetifyOpts = {
  theme: {
    options: { customProperties: true },
    // dark: false,
    icons: {
      iconfont: 'mdiSvg',
    },
    themes: {
      light: {
        primary: '#D7A33B',
        secondary: '#16395A',
        accent: '#2C3F1F',
        error: '#b71c1c',
        base: '#16395A',
        link: '#008bee',
        background: '#F4F9FF',
        task: '#956700',
        event: '#2B3D4B',
        appointment: '#315d42',
        appbar: '#FFFFFF',
        completed: '#FFFFFF',
        past: '#e4ebf1',
        party_header: '#fafafa',
        open: '#16395A',
        closed: '#9E9E9E',
        drawer: '#16395a',
        isPinned: '#F9A825',
        highlight: '#008eff',
        docketLink: '#ffffff',
        disabledText: '#252525',
        peSharedCard: '#fffbee',
      },
      dark: {
        background: '#121212',
        task: '#543a00',
        completed: '#000000',
        event: '#212b34',
        appointment: '#315d42',
        appbar: '#272727',
        party_header: '#0e0e0e',
        drawer: '#0f0f0f',
        past: '#161616',
        highlight: '#fbf2bf',
        docketLink: '#ffffff',
        disabledText: '#e4e4e4',
        peSharedCard: '#2f3021',
      },
    },
  },
}
